import { api } from "./client";
import type { UsageSummary } from "../../types/usage";

export async function getUsageSummary(): Promise<UsageSummary> {
  const response = await api.get("/usage/summary");
  return response.data;
}
